// extracted by mini-css-extract-plugin
export var bannerText = "PricingPanel-module--bannerText--464e4";
export var bannerWrapper = "PricingPanel-module--banner-wrapper--4858d";
export var check = "PricingPanel-module--check--080e3";
export var divider = "PricingPanel-module--divider--79451";
export var faded = "PricingPanel-module--faded--675e2";
export var featuresList = "PricingPanel-module--features-list--6f58c";
export var footnote = "PricingPanel-module--footnote--805bf";
export var hasTextWeightLight = "PricingPanel-module--has-text-weight-light--3e64e";
export var listItem = "PricingPanel-module--list-item--8945d";
export var price = "PricingPanel-module--price--ea3b0";
export var priceAmount = "PricingPanel-module--price-amount--8d04e";
export var priceFrequency = "PricingPanel-module--price-frequency--bcf50";
export var priceLabel = "PricingPanel-module--price-label--2b502";
export var root = "PricingPanel-module--root--5dd45";